import script from "./artShop.vue?vue&type=script&setup=true&lang=js"
export * from "./artShop.vue?vue&type=script&setup=true&lang=js"

import "./artShop.vue?vue&type=style&index=0&id=5bb4604a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb4604a"]])

export default __exports__